<div class="ac-wrap">
  <div #kenttaAlue>
    <mat-form-field>
      <mat-label>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.label' | translate | async }}</mat-label>
      <input
        #kentta
        matInput
        type="text"
        readonly
        [required]="pakollinen"
        class="valitsin"
        [ngModel]="valittuNimi || (uusiToimittajaLomake.enabled ? ('tositteet.lisaa-tositteita.toimittaja-kentta.uusi-toimittaja' | translate | async) : '')"
        [errorStateMatcher]="toimittajaVirheTila"
        (click)="vaihdaTila()"
        (keydown)="kasitteleKentanNappain($event)"
        role="combobox"
        aria-haspopup="listbox"
        [attr.aria-expanded]="pudotusvalikkoAuki"
        [attr.aria-activedescendant]="pudotusvalikkoAuki ? annaVaihtoehdonId(aktiivinenIndeksi) : null"
        [attr.aria-label]="'tositteet.lisaa-tositteita.toimittaja-kentta.valitse-toimittaja-aria' | translate | async"
      />
      <mat-icon matSuffix class="chevron" [class.up]="pudotusvalikkoAuki" (click)="vaihdaTila()" aria-hidden="true">expand_more</mat-icon>
      @if (virhe) {
        <mat-error>{{ virhe | translate | async }}</mat-error>
      }
      @if (infoteksti && !virhe) {
        <mat-hint class="hint success">
          <span class="material-symbols-outlined">check_circle</span>
          {{ infoteksti }}
        </mat-hint>
      }
    </mat-form-field>
  </div>

  @if (uusiToimittajaLomake.enabled) {
    <div class="uusi-toimittaja">
      <div class="uusi-toimittaja-otsikko">
        @if (tekoalynEhdotus) {
          <span class="material-symbols-outlined" aria-hidden="true">auto_awesome</span>
          <span>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.ei-loytynyt-rekisterista' | translate | async }}</span>
        } @else {
          <span class="material-symbols-outlined" aria-hidden="true">add_business</span>
          <span>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.luodaan-tallennettaessa' | translate | async }}</span>
        }
        <button type="button" class="uusi-toimittaja-poista" (click)="peruutaUusiToimittaja()" [attr.aria-label]="'tositteet.lisaa-tositteita.toimittaja-kentta.poista-uusi' | translate | async">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </div>

      <mat-form-field>
        <mat-label>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.uusi-toimittaja-nimi' | translate | async }}</mat-label>
        <input matInput type="text" [formControl]="uusiNimi" [errorStateMatcher]="valitonVirheTila" />
        @if (uusiNimi.invalid) {
          <mat-error>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.nimi-puuttuu' | translate | async }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.ytunnus-placeholder' | translate | async }}</mat-label>
        <input matInput type="text" [formControl]="uusiYtunnus" [errorStateMatcher]="valitonVirheTila" />
        @if (uusiYtunnus.errors?.tunniste) {
          <mat-error>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.ytunnus-virheellinen' | translate | async }}</mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="kenttaAlue" [cdkConnectedOverlayOpen]="pudotusvalikkoAuki" [cdkConnectedOverlayPositions]="paneelinSijainnit" [cdkConnectedOverlayWidth]="paneelinLeveys" (overlayOutsideClick)="kasitteleUlkopuolinenKlikkaus($event)" (detach)="suljePudotusvalikko()">
  <div class="ac-panel" (mousedown)="estaFokuksenSiirto($event)">
    <div class="ac-otsikko">
      <div class="ac-create" [id]="annaVaihtoehdonId(luoUusiIndeksi)" [class.aktiivinen]="aktiivinenIndeksi === luoUusiIndeksi" (click)="luoUusiToimittaja()" role="option" [attr.aria-selected]="aktiivinenIndeksi === luoUusiIndeksi">
        <span class="material-symbols-outlined" aria-hidden="true">add</span>
        @if (hakuteksti.trim()) {
          <span
            >{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.luo-uusi-nimella' | translate | async }} <strong>"{{ hakuteksti.trim() }}"</strong></span
          >
        } @else {
          <span>{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.luo-uusi' | translate | async }}</span>
        }
      </div>
    </div>

    <div class="ac-haku">
      <input
        #hakukentta
        type="text"
        [value]="hakuteksti"
        (input)="paivitaHaku($any($event.target).value)"
        (keydown)="kasitteleHaunNappain($event)"
        [placeholder]="'tositteet.lisaa-tositteita.toimittaja-kentta.hae-placeholder' | translate | async"
        [attr.aria-label]="'tositteet.lisaa-tositteita.toimittaja-kentta.hae-toimittaja-aria' | translate | async"
        [attr.aria-activedescendant]="annaVaihtoehdonId(aktiivinenIndeksi)"
      />
      @if (hakuteksti) {
        <button type="button" class="kuvake-nappi" (click)="tyhjennaHaku()" [attr.aria-label]="'tositteet.lisaa-tositteita.toimittaja-kentta.tyhjenna-haku' | translate | async">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      }
    </div>

    <div class="ac-lista" role="listbox">
      @for (v of vaihtoehdot(); track v.avain; let i = $index) {
        <div class="ac-option" [id]="annaVaihtoehdonId(i)" [class.ac-option-valittu]="v.nimi === valittuNimi" [class.aktiivinen]="i === aktiivinenIndeksi" (click)="valitseToimittaja(v)" role="option" [attr.aria-selected]="v.nimi === valittuNimi">
          <span class="material-symbols-outlined" aria-hidden="true">store</span>
          <div>
            <div>{{ v.nimi }}</div>
            @if (v.ytunnus) {
              <div class="sub">{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.ytunnus' | translate | async }} {{ v.ytunnus }}</div>
            }
          </div>
          @if (v.nimi === valittuNimi) {
            <span class="material-symbols-outlined valittu-check" aria-hidden="true">check</span>
          }
        </div>
      } @empty {
        <div class="ac-option ei-tuloksia">{{ 'tositteet.lisaa-tositteita.toimittaja-kentta.ei-tuloksia' | translate | async }}</div>
      }
    </div>
  </div>
</ng-template>
